// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"ProductListing_mainContent__fwZrn"};